<template>
  <svg width="12" height="11" viewBox="0 0 12 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.07346 6.34918L5.66833 5.75432C6.04438 5.37829 6.04438 4.7686 5.66834 4.39256L1.54002 0.264222C1.18773 -0.0880762 0.616537 -0.0880738 0.264243 0.264228C-0.0880466 0.616525 -0.0880411 1.18771 0.264254 1.54L3.79527 5.07097L0.264223 8.602C-0.0880715 8.95429 -0.0880746 9.52547 0.264215 9.87777C0.616509 10.2301 1.1877 10.2301 1.54 9.87777L5.07101 6.34676L5.07346 6.34918Z" fill="currentColor" />
    <path d="M11.1231 6.34918L11.718 5.75432C12.094 5.37829 12.094 4.7686 11.718 4.39256L7.58966 0.264222C7.23736 -0.0880762 6.66617 -0.0880738 6.31388 0.264228C5.96159 0.616525 5.96159 1.18771 6.31389 1.54L9.84491 5.07097L6.31386 8.602C5.96156 8.95429 5.96156 9.52547 6.31385 9.87777C6.66614 10.2301 7.23733 10.2301 7.58963 9.87777L11.1206 6.34676L11.1231 6.34918Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'ArrowDoubleRight',
};
</script>
